import * as React from 'react';
import flatpickr from "flatpickr";

interface Props {
    onDateChanged(): void;
}

interface State {
    date: any;
}

export default class CustomDateComponent extends React.Component<Props, State> {
    private picker: any;
    private eInput: any;

    constructor(props) {
        super(props);

        this.state = {
            date: null,
        };
    }

    componentDidMount() {
        this.eInput = this.refs.eInput;
        this.eInput.classList.remove('form-control');

        /*let wrapper = document.getElementsByClassName('custom-date-filter');
        if (wrapper && wrapper.length > 0) {
            let children = wrapper[0].children;
            let ourInput = children[1];
            ourInput.classList.remove('form-control');
            this.forceUpdate();
        }*/

        // @ts-ignore
        this.picker = flatpickr(this.refs.flatpickr, {
            onChange: this.onDateChanged,
            wrap: true,
            dateFormat: 'Y-m-d',
            altFormat: "Y-m-d",
            allowInput: true,
            altInput: true,
            /*onClose(dates, currentdatestring, picker){
                picker.setDate(picker.altInput.value, true, picker.config.altFormat)
            }*/
        });

        this.picker.calendarContainer.classList.add('ag-custom-component-popup');
    }

    //*********************************************************************************
    //          METHODS REQUIRED BY AG-GRID
    //*********************************************************************************

    getDate() {
        //ag-grid will call us here when in need to check what the current date value is hold by this
        //component.
        return this.state.date;
    }

    setDate(date) {
        //ag-grid will call us here when it needs this component to update the date that it holds.
        this.setState({ date });
        this.picker.setDate(date);
    }

    //*********************************************************************************
    //          AG-GRID OPTIONAL METHODS
    //*********************************************************************************

    setInputPlaceholder(placeholder) {
        this.eInput.setAttribute('placeholder', placeholder);
    }

    setInputAriaLabel(label) {
        this.eInput.setAttribute('aria-label', label);
    }

    //*********************************************************************************
    //          LINKS THE INTERNAL STATE AND AG-GRID
    //*********************************************************************************

    updateAndNotifyAgGrid(date) {
        this.setState(
            {
                date,
            },
            //Callback after the state is set. This is where we tell ag-grid that the date has changed so
            //it will proceed with the filtering and we can then expect ag-Grid to call us back to getDate
            this.props.onDateChanged
        );
    }

    //*********************************************************************************
    //          LINKING THE UI, THE STATE AND AG-GRID
    //*********************************************************************************

    onDateChanged = (selectedDates, date) => {
        this.updateAndNotifyAgGrid(selectedDates[0])
    };

    onDateInput = (e) => {
        // console.log("Input:", e)
        /*this.setState({ date: selectedDates[0]});
        this.updateAndNotifyAgGrid(selectedDates[0]);*/
    };

    render() {
        return (
            <div
                className="ag-input-wrapper custom-date-filter"
                role="presentation"
                ref="flatpickr"
            >
                <input type="text" data-input style={{ width: '100%' }} ref="eInput" onInput={this.onDateInput}/>
                <a className="input-button" title="clear" data-clear>
                    <i className="fa fa-times"/>
                </a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/common/CustomDateComponent.tsx